import { cellToBoundary } from 'h3-js';
import type { Feature, FeatureCollection, Polygon } from 'geojson';

export function cellsToFeatureCollection(cells: Iterable<string>): FeatureCollection<Polygon> {
  const features: Feature<Polygon>[] = [];
  for (const cell of cells) {
    // h3-js cellToBoundary returns [lat, lng] pairs by default
    const boundary = cellToBoundary(cell, true); // true = GeoJSON-style [lng, lat]
    if (boundary.length === 0) continue;

    // Close the ring
    const ring = boundary.map((p) => [p[0]!, p[1]!] as [number, number]);
    if (ring.length > 0 && (ring[0]![0] !== ring[ring.length - 1]![0] || ring[0]![1] !== ring[ring.length - 1]![1])) {
      ring.push([ring[0]![0], ring[0]![1]]);
    }

    features.push({
      type: 'Feature',
      properties: { h3: cell },
      geometry: { type: 'Polygon', coordinates: [ring] },
    });
  }
  return { type: 'FeatureCollection', features };
}
